import Model from '@ember-data/model';
import attr from 'ember-data/attr';

/*
 * Message's data structure from Gist.
 * - name: message's display name
 * - properties: array of string with a list of message's placeholders
 */
export default class InAppMessageTemplate extends Model {
  @attr('string') name!: string;
  @attr('array') properties!: string[];
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'in-app-message-template': InAppMessageTemplate;
  }
}
